import { render, staticRenderFns } from "./SectionOffice.vue?vue&type=template&id=f90e0c6a&scoped=true&lang=pug&"
import script from "./SectionOffice.vue?vue&type=script&lang=ts&"
export * from "./SectionOffice.vue?vue&type=script&lang=ts&"
import style0 from "./SectionOffice.vue?vue&type=style&index=0&id=f90e0c6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f90e0c6a",
  null
  
)

/* custom blocks */
import block0 from "./SectionOffice.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yml"
if (typeof block0 === 'function') block0(component)
import block1 from "./SectionOffice.vue?vue&type=custom&index=1&blockType=i18n&locale=ja&lang=yml"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LoadImage: require('/app/src/components/atoms/LoadImage.vue').default,SwiperCardLeft: require('/app/src/components/molecules/SwiperCardLeft.vue').default,ShowMoreContent: require('/app/src/components/atoms/ShowMoreContent.vue').default})
